<template>
<!-- 用章管理 -->
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="130px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="企业名称:" prop="enterpriseName">
                <el-input  placeholder="" v-model="searchFrom.enterpriseName"></el-input>
              </el-form-item>
              <!-- <el-form-item label="印章类型:" prop="billType">
              <el-select v-model="searchFrom.billType" placeholder="请选择">
                <el-option  label="请选择" value="" ></el-option>
                <el-option  label="合同章" value="1" ></el-option>
                <el-option  label="财务章" value="2" ></el-option>
              </el-select>
              </el-form-item> -->
              <el-form-item label="统一社会信用代码:" prop="enterpriseNo" class="tong">
                <el-input  placeholder="" v-model="searchFrom.enterpriseNo"></el-input>
              </el-form-item>
            </div>
        </div> 
        <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <div>
              <!-- <el-button type="text" size="mini">签章</el-button> -->
              <el-button type="text" size="mini" @click="record(scope.row)">记录</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="enterpriseName"  min-width="280" :formatter="emptyFn" label="用章企业"></el-table-column>
        <!-- <el-table-column property="billType" label="印章类型" min-width="120">
          <template scope="scope">
            <div>
           {{[ "合同章", "财务章" ][scope.row.billType-1]}}
            </div>
          </template>
        </el-table-column>  -->
        <el-table-column prop="enterpriseNo"  min-width="200" :formatter="emptyFn" label="统一社会信用代码"></el-table-column> 
        <el-table-column prop="num" label="签章数量" width="130">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="numFn(scope.row)">{{scope.row.num}}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createUserName"  width="150" :formatter="emptyFn" label="联系人"></el-table-column>
        <el-table-column prop="applyTel"  min-width="200" :formatter="emptyFn" label="联系电话"></el-table-column>
        <el-table-column prop="createTime"  min-width="200" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog  title="签章数量"  :visible.sync="numClick" width="1000px"   :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
    <div class="imgnum">
      <div v-for="(item,index) in fileList" :key="index">
        <div class="imgBox1" >
          <el-image
            :src="item.signatureUrl" 
            style="width: 230px; height: 230px">
          </el-image> 
          <div :src="item" class="imgapply">
            <p>申请人：{{item.createUserName}}</p>
            <p>申请时间： {{item.createTime|dateFormat}}</p>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="numClick = false" type="primary">关闭</el-button>
    </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { signatureApplyPtList,signatureApplyList } from '@/api/common-signature'
export default {
  data () {
    return {
      signatureUrl: '',
      fileList: [],
      numClick: false,
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      goodTypes: [],
      btnFlg: [],
      btnIdArr: ['004P003B000', '004P003B001', '004P003B002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/systemSetup/address')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    record(row) {
    //  this.$router.push('/useSealRecord')
     this.$router.push({ name: 'useSealRecord', query: { tenantId: row.tenantId } })
    },
    numFn(row) {
      this.numClick = true
      signatureApplyList( { 
        pageNo: 1,
        pageSize: 50,
        tenantId: row.tenantId}).then(res => {
        this.fileList = res.list
      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.billNo) { this.searchFrom.billNos = this.searchFrom.billNo.split(/[(\r\n)\r\n]+/) } else {
        this.searchFrom.billNos = ''
      }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      signatureApplyPtList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        // createTime: null
      }
    },
    closeDialog () {
      
    }
  }
}
</script>

<style scoped lang='less'>
.tong {
  margin-left: 60px;
}
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
.imgnum {
 display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}
.imgBox1 {
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  // flex-wrap: wrap;
  margin: 42px 30px;
}
.imgapply{
  margin-top: 10px;
  margin-left: 17px;
  }
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
</style>
